import styled from 'styled-components';

export const Wrapper = styled.div`
  .ant-input {
    min-width: 250px;
  }
`;
